import { combineReducers } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import appStatusReducer from 'ContentEditorUI/redux/reducers/appStatusReducer';
import baseSettingsReducer from 'ContentEditorUI/redux/reducers/settings/baseSettingsReducer';
// @ts-expect-error not typed
import contentSchemaReducer from 'ContentEditorUI/redux/reducers/contentSchemaReducer';
import panesVisitStatusReducer from 'ContentEditorUI/redux/reducers/panesVisitStatusReducer';
import portalReducer from 'ContentEditorUI/redux/reducers/portalReducer';
import usersReducer from 'ContentEditorUI/js/redux/reducers/usersReducer';
import userAttributesReducer from 'ContentEditorUI/redux/reducers/userAttributesReducer';
import locallyCachedSettingsReducer from 'ContentEditorUI/redux/reducers/locallyCachedSettingsReducer';
import { sidebarStateReducer } from 'ContentEditorUI/redux/reducers/sidebarStateReducer';
import selectionReducer from 'ContentEditorUI/redux/reducers/selectionReducer';
// @ts-expect-error not typed
import iframesReducer from 'ContentEditorUI/redux/reducers/iframesReducer';
import brandSettingsReducer from 'ContentEditorUI/redux/reducers/brandSettingsReducer';
import sectionsReducer from 'ContentEditorUI/redux/reducers/sectionsReducer';
import modalReducer from 'ContentEditorUI/redux/reducers/modalReducer';
// @ts-expect-error not typed
import createCollaborationSidebarReducer from 'ContentEditorUI/redux/reducers/createCollaborationSidebarReducer';
import locationReducer from 'ContentEditorUI/redux/reducers/locationReducer';
import immutableToImmerReducer from 'ContentEditorUI/redux/reduxReducerDiffer';
import { runDiffsOnFiftyPercentOfAppLoads } from 'ContentEditorUI/redux/reducers/reduxReducerDifferUtils';

// Modules
// @ts-expect-error not typed
import justSavedModuleReducer from 'ContentEditorUI/redux/reducers/justSavedModuleReducer';
import editSidebarReducer from 'ContentEditorUI/redux/reducers/editSidebarReducer';
import moduleSchemaReducer from 'ContentEditorUI/redux/reducers/moduleSchemaReducer';
import moduleReducer, { compareModuleReducerSlices, moduleReducerAsJSObject } from 'ContentEditorUI/redux/reducers/moduleReducer';
import createUndoableModuleReducer, { createUndoableModuleReducerAsPOJO } from 'ContentEditorUI/redux/reducers/undoableModuleReducer';
import moduleErrorReducer from 'ContentEditorUI/redux/reducers/moduleErrorReducer';
import deleteRequestReducer from 'ContentEditorUI/redux/reducers/deleteRequestReducer';
import cloneRequestReducer from 'ContentEditorUI/redux/reducers/cloneRequestReducer';

// Content
import resources from 'ContentData/reducers/Resources';
// @ts-expect-error not typed
import editingInfoReducer from 'ContentEditorUI/redux/reducers/editingInfoReducer';
import saveDataReducer from 'ContentEditorUI/redux/reducers/saveDataReducer';
import formStatusReducer from 'ContentEditorUI/redux/reducers/formStatusReducer';
import abTestReducer from 'ContentEditorUI/redux/reducers/abTestReducer';
import accountVerificationStatusReducer from 'ContentEditorUI/redux/reducers/accountVerificationStatusReducer';
import contentDataReducer from 'ContentEditorUI/redux/reducers/contentReadOnlyDataReducer';
import layoutDataReducer from 'ContentEditorUI/redux/reducers/layoutDataReducer';
import languageReducer from 'ContentEditorUI/redux/reducers/languageReducer';
import revisionsReducer from 'ContentEditorUI/redux/reducers/revisionsReducer';
import hardSavedContentModelReducer from 'ContentEditorUI/redux/reducers/contentModel/hardSavedContentModelReducer';
import styleBreakpointsReducer from 'ContentEditorUI/redux/reducers/styleBreakpointsReducer';
import contentAssetsReducer from 'ContentEditorUI/redux/reducers/contentAssetsReducer';
import optimizationsReducer from 'ContentEditorUI/redux/reducers/optimizationsReducer';
import inpageOptimizationsReducer from 'ContentEditorUI/redux/reducers/inpageOptimizationReducer';
import headerReducer from 'ContentEditorUI/redux/reducers/headerReducer';

// Smart View
import smartViewReducer from 'ContentEditorUI/redux/reducers/smartViewReducer';

// Inpage Editor
import inpageReducer from 'ContentEditorUI/redux/reducers/inpageReducer';
import inpageModals from 'tinymce-plugins/reducers/InpageModals';
import siteSettingsReducer from 'ContentEditorUI/redux/reducers/siteSettingsReducer';
import portalDomainsReducer from 'ContentEditorUI/redux/reducers/portalDomainsReducer';
import templateInfoReducer from 'ContentEditorUI/redux/reducers/templateInfoReducer';
import themeReducer from 'ContentEditorUI/redux/reducers/themeReducer';
import uploadedFeaturedImagesReducer from 'ContentEditorUI/redux/reducers/uploadedFeaturedImagesReducer';
import testFlagsReducer from 'ContentEditorUI/redux/reducers/testFlagsReducer';
import baseContentModelReducer, { baseContentModelReducerAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/baseContentModelReducer';
// Instance editing
import { structuredContent } from 'structured-content-lib/redux/reducers/index';
import revisionHistoryReducer from 'structured-content-lib/redux/reducers/revisionHistoryReducer';
import createRequestStatesReducer from 'ContentEditorUI/redux/reducers/createRequestStatesReducer';
// Content assistant
import contentAssistantReducer from 'ContentEditorUI/redux/reducers/contentAssistantReducer';
import knowledgeBaseGroup from './knowledgeBaseReducer';
// @ts-expect-error not typed
import Notifications from 'ReduxMessenger/reducers/Notifications';
import { auth } from '../auth/reducers/auth';
import { extraInitialStateReducer } from './extraInitialStateReducer';
// @ts-expect-error not typed yet
import { enableModuleReducerDiffing } from 'ContentEditorUI/utils/moduleReducerUtils';
import { gate } from 'hub-http/gates';
enableModuleReducerDiffing();
const diffedUndoableModuleReducer = immutableToImmerReducer(createUndoableModuleReducer(moduleReducer),
// @ts-expect-error getting some weird TS errors with immutable.
// Ignoring the error for now as this will be temporary
createUndoableModuleReducerAsPOJO(moduleReducerAsJSObject), {
  reducerName: 'modules',
  reducerToReturn: {
    type: 'gated',
    gateName: gate('ContentEditorUI:ImmerModuleSelectors')
  },
  prodConfig: {
    computeDiffOnProd: 'conditionally',
    condition: runDiffsOnFiftyPercentOfAppLoads
  },
  serializeImmutableState: immutableState => immutableState.get('present').toJS(),
  computeStateDiff: (immutablePresentState, immerUndoableState) => compareModuleReducerSlices(immutablePresentState, immerUndoableState.present)
});
export function useAppDispatch() {
  return useDispatch();
}
export function useAppSelector(selector) {
  return useSelector(selector);
}
export const rootReducer = combineReducers({
  auth,
  baseModalSettings: baseSettingsReducer,
  saveData: saveDataReducer,
  extraInitialState: extraInitialStateReducer,
  abTest: abTestReducer,
  accountVerificationStatus: accountVerificationStatusReducer,
  appStatus: appStatusReducer,
  brandSettings: brandSettingsReducer,
  collaborationSidebar: createCollaborationSidebarReducer(),
  contentReadOnlyData: contentDataReducer,
  contentAssets: contentAssetsReducer,
  contentAssistant: contentAssistantReducer,
  contentSchema: contentSchemaReducer,
  editSidebar: editSidebarReducer,
  panesVisitStatus: panesVisitStatusReducer,
  portalDomains: portalDomainsReducer,
  portal: portalReducer,
  editingInfo: editingInfoReducer,
  formStatus: formStatusReducer,
  iframes: iframesReducer,
  inpageData: inpageReducer,
  inpageModals,
  knowledgeBaseGroup,
  structuredContent,
  styleBreakpoints: styleBreakpointsReducer,
  justSavedModule: justSavedModuleReducer,
  locallyCachedSettings: locallyCachedSettingsReducer,
  moduleErrors: moduleErrorReducer,
  deleteRequest: deleteRequestReducer,
  cloneRequest: cloneRequestReducer,
  moduleSchemas: moduleSchemaReducer,
  modules: diffedUndoableModuleReducer,
  siteSettings: siteSettingsReducer,
  revisions: revisionsReducer,
  revisionHistory: revisionHistoryReducer,
  resources,
  selection: selectionReducer,
  sidebarState: sidebarStateReducer,
  smartView: smartViewReducer,
  templateInfo: templateInfoReducer,
  testFlags: testFlagsReducer,
  theme: themeReducer,
  uploadedFeaturedImages: uploadedFeaturedImagesReducer,
  users: usersReducer,
  layoutData: layoutDataReducer,
  languages: languageReducer,
  userAttributes: userAttributesReducer,
  hardSavedContentModel: hardSavedContentModelReducer,
  sections: sectionsReducer,
  modals: modalReducer,
  optimizationState: optimizationsReducer,
  inpageOptimizationState: inpageOptimizationsReducer,
  header: headerReducer,
  __location: locationReducer,
  requestStates: createRequestStatesReducer(),
  contentModel: immutableToImmerReducer(baseContentModelReducer, baseContentModelReducerAsJSObject, {
    reducerName: 'contentModel',
    reducerToReturn: {
      type: 'gated',
      gateName: 'ContentEditorUI:ImmerContentModel'
    },
    prodConfig: {
      computeDiffOnProd: 'conditionally',
      condition: runDiffsOnFiftyPercentOfAppLoads
    }
  }),
  notifications: Notifications
});
export const initialState = rootReducer(undefined, {
  type: 'START_APP'
});